import React from "react";
import ReactDOM from "react-dom";
import {LargeGrantApplication} from "../components/LargeGrantApplication";

export const insertLargeGrantApplication = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="large-grant-application"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<LargeGrantApplication />, element);
  });
};
